import React from 'react';
import { connect } from 'react-redux';
import { isNil } from 'lodash';

import { selectCurrentSalonFlags } from 'selectors/currentSalon.selectors';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import fromAnyToString from 'utils/converters/fromAnyToString';
import { isEnvBeta, isEnvDev } from 'utils/env/determine.util';

const { cloneElement } = React;
const { map, toArray } = React.Children;

const IS_DEV = isEnvDev();
const IS_BETA = isEnvBeta();

const IfEnabled = ({ children, flag }) => (flag === true ? <>{children}</> : null);
const IfNotEnabled = ({ children, flag }) => (flag !== true ? <>{children}</> : null);
const IfDisabled = ({ children, flag }) => (flag === false ? <>{children}</> : null);
const IfMissing = ({ children, flag }) => (flag === null ? <>{children}</> : null);
const IfDevelopment = ({ children }) => (IS_DEV ? <>{children}</> : null);
const IfBeta = ({ children }) => (IS_BETA ? <>{children}</> : null);

const isValidChild = ({ type }) =>
  type === IfEnabled || type === IfNotEnabled || type === IfDisabled || type === IfMissing || type === IfDevelopment;

const SalonFlag = ({ name, flags, children }) => {
  const key = fromAnyToString(name);
  const val = flags?.[key];
  const flag = isNil(val) ? null : fromAnyToBool(val);

  return <>{map(toArray(children).filter(isValidChild), (child) => cloneElement(child, { flag }))}</>;
};

const SalonFlagHoC = connect((state) => ({
  flags: selectCurrentSalonFlags(state),
}))(SalonFlag);

Object.assign(SalonFlagHoC, { IfEnabled, IfNotEnabled, IfDisabled, IfMissing, IfDevelopment, IfBeta });

// noinspection JSUnusedGlobalSymbols
export default SalonFlagHoC;
